import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { Typography, Grid, RaiseColors, Divider, InfoIconPopper, useTheme } from "componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TableDataCards = function TableDataCards(_ref) {
  var dataList = _ref.dataList,
    headers = _ref.headers,
    isMobile = _ref.isMobile,
    cardHeader = _ref.cardHeader,
    onCardClick = _ref.onCardClick;
  var TableDataCard = function TableDataCard(_ref2) {
    var _useWindowSize$innerW;
    var item = _ref2.item,
      rowIndex = _ref2.rowIndex,
      onCardClick = _ref2.onCardClick;
    var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
    var theme = useTheme();
    var isPhone = windowSize < _valuesInstanceProperty(theme.breakpoints).smMd;
    return /*#__PURE__*/_jsx(Grid, {
      container: true,
      spacing: 1,
      onClick: function onClick(event) {
        return onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick(item, rowIndex, event);
      },
      style: {
        cursor: "pointer"
      },
      children: _mapInstanceProperty(headers).call(headers, function (header, cellIndex) {
        return /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsx(Grid, {
            item: true,
            xs: 12,
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: isPhone ? "12px" : "40px"
              },
              children: [header.columnName && /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  alignItems: "center",
                  flexShrink: 0
                },
                children: [/*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph_xsmall",
                  weight: "medium",
                  color: RaiseColors.grayscale900,
                  children: header.columnName
                }), header.infoText && /*#__PURE__*/_jsx(InfoIconPopper, {
                  title: header.columnName,
                  infoText: header.infoText,
                  useMobile: isMobile,
                  style: {
                    marginLeft: 8
                  }
                })]
              }), header.renderCell({
                item: item,
                rowIndex: rowIndex,
                usingTable: false
              })]
            })
          }, cellIndex)
        }, cellIndex);
      })
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      padding: 16
    },
    children: [cardHeader && /*#__PURE__*/_jsx("div", {
      style: {
        paddingBottom: "16px"
      },
      children: /*#__PURE__*/_jsx(Typography, {
        weight: "bold",
        variant: "h2",
        children: cardHeader
      })
    }), _mapInstanceProperty(dataList).call(dataList, function (item, rowIndex, arr) {
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(TableDataCard, {
          item: item,
          headers: headers,
          isMobile: isMobile,
          rowIndex: rowIndex,
          onCardClick: onCardClick
        }), rowIndex !== arr.length - 1 && /*#__PURE__*/_jsx(Divider, {
          style: {
            marginTop: 24,
            marginBottom: 24
          },
          color: RaiseColors.neutral300
        })]
      }, rowIndex);
    })]
  });
};
export default TableDataCards;
export var TableDataCard = function TableDataCard(_ref3) {
  var item = _ref3.item,
    rowIndex = _ref3.rowIndex,
    headers = _ref3.headers,
    isMobile = _ref3.isMobile,
    onCardClick = _ref3.onCardClick;
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    spacing: 1,
    onClick: function onClick(event) {
      return onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick(item, rowIndex, event);
    },
    style: {
      cursor: "pointer",
      width: "100%"
    },
    children: _mapInstanceProperty(headers).call(headers, function (header, cellIndex) {
      return /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px",
            width: "100%"
          },
          children: [header.columnName && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              alignItems: "center",
              flexShrink: 0
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "paragraph_xsmall",
              weight: "medium",
              color: RaiseColors.grayscale900,
              children: header.columnName
            }), header.infoText && /*#__PURE__*/_jsx(InfoIconPopper, {
              title: header.columnName,
              infoText: header.infoText,
              useMobile: isMobile,
              style: {
                marginLeft: 8
              }
            })]
          }), header.renderCell({
            item: item,
            rowIndex: rowIndex,
            usingTable: false
          })]
        })
      }, cellIndex);
    })
  });
};